import { useState, useCallback } from 'react'
import { numberFormat } from 'shared/util'

import { Stack } from '@mui/material'

import { Loading } from 'components/controls/loading'
import { ErrorInfo } from 'components/controls/errorInfo'
import { ValueSpan } from 'components/controls/valueSpan'
import { SearchTableBody } from 'components/controls/searchTable'

import { NotificationResult } from 'interface/notification'

import { useNotificationManagementContainer } from './container'

import { ConfigureListHeader } from '../components/header'
import { AddNotificationDialog } from 'features/notification/dialog/add'
import { EditNotificationDialog } from 'features/notification/dialog/edit'

export const ConfigureNotificationPage = () => {
  const {
    loading,
    error,
    notificationList,
    searchWord,
    setSearchWord,
		onAddNotification,
		onEditNotification,
		onDeleteNotification,
  } = useNotificationManagementContainer()

	const [modal, setModal] = useState<{
		mode: "addNotification" | "editNotification"
		notification?: NotificationResult
  } | null>(null)

	const closeModal = useCallback(
		() => setModal(null),
		[setModal]
	)
	const openAddNotificationDialog = useCallback(
		() => setModal({ mode: "addNotification" }),
		[setModal]
	)
	const openEditNotificationDialog = useCallback(
		(notification: NotificationResult) => setModal({ mode: "editNotification", notification }),
		[setModal]
	)
  return (
    <>
      {loading && <Loading />}

      <ConfigureListHeader
        openAddButtonLabel="新しいお知らせ"
        openAddDialog={openAddNotificationDialog}
        searchWord={searchWord}
        setSearchWord={setSearchWord}
      >
        <ValueSpan text={numberFormat(notificationList?.length, '')} suffix='件'/>
      </ConfigureListHeader>
      
      <Stack direction="column" spacing={1}>
        {error && <ErrorInfo error={error}/>}
      </Stack>

      {notificationList && (
        <SearchTableBody<NotificationResult>
          list={notificationList}
          columnList={[
            { label: 'タイトル', value: (r) => r.title, expand: true },
            { label: '全テナント共通', value: (r) => r.isGrobal === true ? '共通' : '－', align: 'center' },
            { label: 'ログイン画面に表示', value: (r) => r.isOpen === true ? '表示' : '－', align: 'center' },
          ]}
          onClickRow={openEditNotificationDialog}
        />
      )}

      {modal?.mode === 'addNotification' ? (
        <AddNotificationDialog
          onAddNotification={onAddNotification}
          onClose={closeModal}
        />
      ) : (modal?.mode === 'editNotification' && modal?.notification) ? (
        <EditNotificationDialog
          notification={modal.notification}
          onDeleteNotification={onDeleteNotification}
          onEditNotification={onEditNotification}
          onClose={closeModal}
        />
      ) : (
        <></>
      )}
    </>
  )
}
